import { useState } from 'react';
import { api } from '../../api.js';
import Field from '../../components/Field.jsx';
import Alert from '../../components/ui/Alert.jsx';
import Modal, { ModalActions } from '../../components/ui/Modal.jsx';
import { VerifiedSeal } from '../../components/ui/VerifiedSeal.jsx';

const ANSWER = {
  official: { tone: 'info', title: 'Official', text: (r, name) => `This is one of ${name}’s official channels${r.label ? ` (${r.label})` : ''}.` },
  not_ours: { tone: 'warn', title: 'Not ours', text: (r, name) => `This isn’t one of ${name}’s official channels.` },
  reported: { tone: 'danger', title: 'Reported scam', text: (r) => `Not ours, and reported ${r.report_count} time${r.report_count === 1 ? '' : 's'}${r.other_event_count > 1 ? ` across ${r.other_event_count} events` : ''}.` },
  invalid: { tone: 'info', title: 'Couldn’t tell what that is', text: () => 'Paste an email address, website, phone number or bank details.' },
};

/**
 * Try a check exactly as the public verify page would answer it — available in test
 * mode and for drafts, so organisers see what people will be told before going public.
 */
export default function CheckPreviewModal({ event, onClose }) {
  const [q, setQ] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const check = async () => {
    if (!q.trim()) return;
    setBusy(true); setError('');
    try { setResult(await api(`/portal/events/${event.id}/check?q=${encodeURIComponent(q.trim())}`)); }
    catch (err) { setError(err.message); }
    setBusy(false);
  };

  const a = result && ANSWER[result.verdict];
  return (
    <Modal title="Try a check" onClose={onClose} onSubmit={check} busy={busy}
      description="Paste an email address, link, phone number or bank details to see what the verify page would answer. Only you can see this."
      footer={<ModalActions submitLabel="Check" busyLabel="Checking…" busy={busy} onCancel={onClose} cancelLabel="Close" disabled={!q.trim()} />}>
      {error && <Alert tone="danger">{error}</Alert>}
      <Field label="What do you want to check?" value={q} onChange={(e) => { setQ(e.target.value); setResult(null); }}
        placeholder="bookings@techsummit-hotels.com" autoComplete="off" spellCheck={false} />
      {a && <Alert tone={a.tone} title={result.verdict === 'official' ? <span className="title-with-pill"><VerifiedSeal size={18} /> Official</span> : a.title}>{a.text(result, event.name)}</Alert>}
    </Modal>
  );
}
